module.exports = __webpack_public_path__ + "3e7b349e2aea266f98a0bb7b268a3b7b.glb";